import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getMonthToDate,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getSelectedRangeOption
} from "../../../../../utils/date-range-options";
import {
  SET_LOADING,
  SET_TABLE_DATA_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_CHART_SUCCESS,
  FETCH_TABLE_DATA_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  UPDATE_CLASS_FILTERS,
  UPDATE_STAFF_FILTERS,
  UPDATE_CHART_SUCCESS,
  SET_FILTERS_DIRTY,
  SET_DATES,
  UPDATE_DATES,
  RESET_TABLE_DATA,
  UPDATE_CUSTOM_RANGE,
  UPDATE_FILTERS_SUCCESS,
  UPDATE_CATEGORY_FILTER,
  RESET_CATEGORY_FILTER,
  SET_CLASS_FILTERS_LOADING,
  SET_STAFF_FILTERS_LOADING,
  UPDATE_FILTERS_BY_STAFF_SUCCESS,
  UPDATE_FILTERS_BY_CLASS_SUCCESS,
  SET_PRIMARY_FILTER,
  SET_CUSTOM_DATE_RANGE_LOADING,
  FETCH_GRAPH_SUCCESS,
  UPDATE_PERIOD_TYPE_SELECTED,
  YEAR_OVER_YEAR_LOADING,
  SET_UPDATES_LOADING,
  UPDATE_TYPE_FILTER_SELECTED,
  RESET_TYPE_FILTER_SELECTED,
  CHANGE_TOGGLE_SUCCESS
} from "../sagas/utilization/utilization";
import startCase from "lodash/startCase";

function formatCategories(data) {
  const newData = [];
  data.map((item, i) => {
    var obj = {};
    obj.id = i + 1;
    obj.name = item[1];
    newData.push(obj);
  });
  return newData;
}

function formatCat(data) {
  let newData;
  if (data.name === "Average Class Size") {
    newData = {
      id: data.id,
      name: "average_class_size"
    };
  }
  if (startCase(data.name) === startCase("Number of Clients")) {
    newData = {
      id: data.id,
      name: "total_number_of_clients"
    };
  }
  if (data.name === "Utilization") {
    newData = {
      id: data.id,
      name: "utilization"
    };
  }
  if (data.name === "Average Revenue") {
    newData = {
      id: data.id,
      name: "average_revenue"
    };
  }
  return newData;
}

function filterValues(data) {
  const newData = [];
  data.map((item) => {
    if (item.selected) {
      newData.push(item);
    }
  });
  return newData;
}

function removeCheckedClass(data) {
  const newClassData = [];
  data.class_values.map((item) => {
    if (item.selected) {
      newClassData.push(item);
    }
  });
  const newData = { staff_values: data.staff_values, class_values: newClassData };
  return newData;
}

function removeCheckedStaff(data) {
  const newClassData = [];
  data.staff_values.map((item) => {
    if (item.selected) {
      newClassData.push(item);
    }
  });
  const newData = { staff_values: newClassData, class_values: data.class_values };
  return newData;
}

function getSelectedCategoryName(category) {
  let categoryName;
  if (category === "utilization") {
    categoryName = "Utilization";
  }
  if (category === "total_number_of_clients") {
    categoryName = "Number of Clients";
  }
  if (category === "average_class_size") {
    categoryName = "Average Class Size";
  }
  if (category === "average_revenue") {
    categoryName = "Average Revenue";
  }
  return categoryName;
}

function getChartCurrencySymbol(selectedCategoryFilters, action, fallbackCurrency) {
  switch (selectedCategoryFilters.name) {
    case "average_revenue":
      return action.payload.currency || fallbackCurrency;
    case "utilization":
      return "%";
    default:
      return "";
  }
}

function getDataPointsWithTotal(state, payload) {
  const { current_value, growth_value, url, utilization_by_category } = payload;
  const categoryName = state.selectedCategoryFiltersDisplay.name;
  const otherDataPoints = utilization_by_category;

  const total = {
    label: "Total " + categoryName,
    value: current_value,
    growth: growth_value / 100,
    changeTooltip: "Percentage change from previous period",
    url: url
  };

  return { utilization_by_category: [total, ...otherDataPoints] };
}

export const initialState = {
  currentUser: {},
  numberOfMonths: null,
  graphData: {},
  series: [],
  isLoading: true,
  updatesLoading: false,
  modalTableData: {},
  filters: {},
  tableDataLoading: true,
  selectedClassFilters: {},
  selectedStaffFilters: {},
  filtersDirty: false,
  selectedRequestDates: {},
  staffFiltersLoading: false,
  classFiltersLoading: false,
  customDateRangeLoading: false,
  primaryFilter: "",
  datesDirty: false,
  categories: [],
  periodType: "Weekly",
  yearOverYearLoading: true,
  chartCurrencySymbol: "%",
  currentSelectedCategory: "Utilization",
  selectedPeriodType: {
    id: 2,
    name: "Weekly"
  },
  periodTypeOptions: [
    {
      id: 1,
      name: "Daily"
    },
    {
      id: 2,
      name: "Weekly"
    },
    {
      id: 3,
      name: "Monthly"
    },
    {
      id: 4,
      name: "Yearly"
    }
  ],
  selectedCategoryFilters: {
    id: 1,
    name: "utilization"
  },
  selectedCategoryFiltersDisplay: {
    id: 1,
    name: "Utilization"
  },
  selectedRangeOption: {},
  rangeOptions: [],
  typeOptions: [
    {
      id: 1,
      name: "Virtual"
    },
    {
      id: 2,
      name: "Physical"
    },
    {
      id: 3,
      name: "All"
    }
  ],
  selectedTypeOption: {
    id: 2,
    name: "Physical"
  },
  groupByWeekDay: false,
  showUtilizationPrevPeriod: true
};

function adjustForNestedRows(tableInfo, organization) {
  const { colHeaders = [], data = [] } = tableInfo;
  let ind = tableInfo.colHeaders.findIndex((el) => el == "Utilization");

  if (ind >= 0) {
    let firstLevelHeaders = colHeaders.slice(0, ind + 1);
    let nestedHeaders = colHeaders.slice(ind + 1);
    let offset = nestedHeaders.length == 5 ? 0 : 1;

    let formattedData = [];
    data.forEach((rowArr, index) => {
      formattedData[index] = {
        ...firstLevelHeaders.reduce((acc, header, index) => {
          let key = header.toLowerCase();
          let val = rowArr[index];
          let nestedHeader = colHeaders[index + ind + offset];
          let nestedRowVal = rowArr[index + ind + offset];
          let children = [];
          let omitFirstCell = key == "instructor" && offset == 0;

          children[0] = {
            ...acc?.__children?.[0],
            [key]: omitFirstCell ? null : nestedHeader
          };

          children[1] = {
            ...acc?.__children?.[1],
            [key]: omitFirstCell ? null : nestedRowVal
          };

          acc = {
            ...acc,
            [key]: val,
            __children: children
          };
          return acc;
        }, {})
      };
    });
    return {
      data: formattedData,
      colHeaders: firstLevelHeaders,
      sourceType: organization
    };
  }

  return tableInfo;
}

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [YEAR_OVER_YEAR_LOADING]: (state, action) => ({
      ...state,
      yearOverYearLoading: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload,
      datesDirty: action.payload
    }),
    [RESET_TABLE_DATA]: (state, action) => ({
      ...state,
      series: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptions(action.payload.endDate, state.currentUser.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.calendarStartDate
      ),
      filtersDirty: true,
      datesDirty: true
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true,
      datesDirty: true
    }),
    [SET_TABLE_DATA_LOADING]: (state, action) => ({
      ...state,
      tableDataLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload.currentUser || state.currentUser,
      numberOfMonths: action.payload.numberOfMonths || state.numberOfMonths,
      groupByWeekDay: false,
      showUtilizationPrevPeriod: true
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      series: action.payload || state.series,
      currentSelectedCategory: getSelectedCategoryName(state.selectedCategoryFilters.name)
    }),
    [FETCH_GRAPH_SUCCESS]: (state, action) => ({
      ...state,
      graphData:
        {
          ...action.payload,
          ...getDataPointsWithTotal(state, action.payload)
        } || state.graphData,
      chartCurrencySymbol: getChartCurrencySymbol(
        state.selectedCategoryFilters,
        action,
        state.chartCurrencySymbol
      ),
      yearOverYearLoading: false
    }),
    [UPDATE_CHART_SUCCESS]: (state, action) => ({
      ...state,
      series: action.payload || state.series,
      chartCurrencySymbol: getChartCurrencySymbol(
        state.selectedCategoryFilters,
        action,
        state.chartCurrencySymbol
      ),
      currentSelectedCategory: getSelectedCategoryName(state.selectedCategoryFilters.name),
      showUtilizationPrevPeriod: !state.groupByWeekDay
    }),
    [FETCH_TABLE_DATA_SUCCESS]: (state, action) => ({
      ...state,
      modalTableData: adjustForNestedRows(
        action.payload.tableInfo || state.modalTableData,
        state.currentUser.sourceType
      ),
      tableDataLoading: false
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload || state.filters,
      categories: formatCategories(action.payload.category_types),
      selectedClassFilters: action.payload.class_values || state.selectedClassFilters,
      selectedStaffFilters: action.payload.staff_values || state.selectedStaffFilters
    }),
    [UPDATE_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      categories: formatCategories(action.payload.category_types),
      selectedClassFilters: removeCheckedClass(action.payload.class_values),
      selectedStaffFilters: removeCheckedStaff(action.payload.staff_values)
    }),
    [UPDATE_FILTERS_BY_STAFF_SUCCESS]: (state, action) => ({
      ...state,
      filters: removeCheckedClass(action.payload),
      selectedClassFilters: filterValues(action.payload.class_values),
      classFiltersLoading: false
    }),
    [UPDATE_FILTERS_BY_CLASS_SUCCESS]: (state, action) => ({
      ...state,
      filters: removeCheckedStaff(action.payload),
      selectedStaffFilters: filterValues(action.payload.staff_values),
      staffFiltersLoading: false
    }),
    [UPDATE_CLASS_FILTERS]: (state, action) => ({
      ...state,
      selectedClassFilters: action.payload || state.selectedClassFilters,
      filtersDirty: true
    }),
    [UPDATE_CATEGORY_FILTER]: (state, action) => ({
      ...state,
      selectedCategoryFilters: formatCat(action.payload),
      selectedCategoryFiltersDisplay: action.payload,
      filtersDirty: true
    }),
    [RESET_CATEGORY_FILTER]: (state, action) => ({
      ...state,
      selectedCategoryFilters: formatCat(action.payload),
      selectedCategoryFiltersDisplay: action.payload
    }),
    [UPDATE_STAFF_FILTERS]: (state, action) => ({
      ...state,
      selectedStaffFilters: action.payload || state.selectedStaffFilters,
      filtersDirty: true
    }),
    [UPDATE_TYPE_FILTER_SELECTED]: (state, action) => ({
      ...state,
      selectedTypeOption: action.payload || state.selectedTypeOption,
      filtersDirty: true
    }),
    [RESET_TYPE_FILTER_SELECTED]: (state, action) => ({
      ...state,
      selectedTypeOption: action.payload
    }),
    [UPDATE_PERIOD_TYPE_SELECTED]: (state, action) => ({
      ...state,
      periodType: action.payload.name,
      selectedPeriodType: action.payload
    }),
    [SET_CLASS_FILTERS_LOADING]: (state, action) => ({
      ...state,
      classFiltersLoading: action.payload
    }),
    [SET_STAFF_FILTERS_LOADING]: (state, action) => ({
      ...state,
      staffFiltersLoading: action.payload
    }),
    [SET_CUSTOM_DATE_RANGE_LOADING]: (state, action) => ({
      ...state,
      customDateRangeLoading: action.payload
    }),
    [SET_PRIMARY_FILTER]: (state, action) => ({
      ...state,
      primaryFilter: action.payload
    }),
    [CHANGE_TOGGLE_SUCCESS]: (state, action) => ({
      ...state,
      groupByWeekDay: action.payload
    })
  },
  initialState
);
